module.exports = __webpack_public_path__ + "img/mobile_map_barcellona.2df28d36.svg";